export const CLEAR_MULTI_ADD_ANCHOR = 'ops.rows.add-anchor.clear.CLEAR_MULTI_ADD_ANCHOR' as const;

export type ClearMultiAddAnchorAction = {
	type: typeof CLEAR_MULTI_ADD_ANCHOR;
};

export const clear = (): ClearMultiAddAnchorAction => ({
	type: CLEAR_MULTI_ADD_ANCHOR,
});
